jQuery(document).ready(function($){
    $('.slick-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1, 
        centerMode: true,

        autoplay: false, 
        // autoplaySpeed: 2300, 
        dots: true, 
        arrows: true, 
        prevArrow: '<button type="button" role="button" tabindex="0" class="slick-prev">Button to go to previous slide</button>',
        nextArrow: '<button type="button" role="button" tabindex="0" class="slick-next">Button to go to next slide</button>',  
        infinite: true, 
        initialSlide: 1 
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        const slides = document.querySelectorAll('.slick-slider .slick-slide');
        slides.forEach((slide) => {
          slide.classList.remove('slick-problem'); 
        })
        if(nextSlide === 0 && currentSlide === slick.$slides.length - 1) {
          problemObject = document.querySelector('.slick-slider .slick-center + .slick-cloned');
          problemObject.classList.add('slick-problem') 
        } else if(nextSlide === slick.$slides.length - 1 && currentSlide === 0) {
          problemObject = document.querySelector('.slick-slider .slick-cloned:has(+ .slick-center)');
          problemObject.classList.add('slick-problem')
        }
      }); 
});
